export default __webpack_public_path__ + "static/media/value.1c2ddb31.svg";